import React from 'react';

import logoDark from '../../../images/korecki-logo-dark.png';
import monday from '../../../images/monday.png';
import reach from '../../../images/reach.png';
import rentcafe from '../../../images/rentcafe.png';
import vts from '../../../images/vts.png';
import yardi from '../../../images/yardi.png';

export default function Footer() {
  return (
    <footer className="modern-footer">

      <div className="modern-footer-top">

        <div className="modern-footer-column">

          <img
            src={logoDark}
            alt="Korecki"
            className="modern-footer-logo"
          />

          <p>
            A locally owned and operated Property Management Company,
            administering all building operations from our Vancouver office.
          </p>

          <div className="partner-marquee">
            <div className="partner-track">

              <img src={yardi} alt="Yardi" />
              <img src={vts} alt="VTS" />
              <img src={rentcafe} alt="RentCafe" />
              <img src={monday} alt="Monday" />
              <img src={reach} alt="Reach" />

              {/* duplicados para scroll infinito */}

              <img src={yardi} alt="Yardi" />
              <img src={vts} alt="VTS" />
              <img src={rentcafe} alt="RentCafe" />
              <img src={monday} alt="Monday" />
              <img src={reach} alt="Reach" />

            </div>
        </div>
        </div>
        <div className="modern-footer-column">

          <h4>SERVICES</h4>

          <a href="https://korecki.ca/strata-management-services">
            Strata Management
          </a>

          <a href="https://korecki.ca/rental-management-services">
            Rental Management
          </a>

          <a href="https://korecki.ca/developers">
            Developer Services
          </a>

          <a href="https://korecki.ca/documents">
            Documents & Forms
          </a>

          <a href="https://korecki.ca/listings">
            Listings
          </a>

        </div>

        <div className="modern-footer-column">

          <h4>CONTACT</h4>

          <p>
            605 – 1166 Alberni St
            <br />
            Vancouver, BC
          </p>

          <p>(604) 233-7772</p>

          <p>info@korecki.ca</p>

        </div>

        <div className="modern-footer-column">

          <h4>FOLLOW US</h4>

          <a
            href="https://www.facebook.com/koreckirealestate"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook
          </a>

          <a
            href="https://www.linkedin.com/company/korecki-real-estate-services-inc-/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>

          <a
            href="https://www.instagram.com/koreckire"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>

        </div>

      </div>

      <div className="modern-footer-bottom">

        <div>
          © {new Date().getFullYear()} Korecki Real Estate Services Inc.
          All rights reserved.
        </div>

        <div className="footer-links">

          <a href="https://korecki.ca/contact">
            Contact
          </a>

          <a href="https://korecki.ca/services">
            Areas & Properties We Serve
          </a>

          <a href="https://korecki.ca/portal-access">
            Client Portal
          </a>

        </div>

      </div>

    </footer>
  );
}